import { render, staticRenderFns } from "./StarterSite.vue?vue&type=template&id=5530ee93&"
import script from "./StarterSite.vue?vue&type=script&lang=js&"
export * from "./StarterSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5530ee93')) {
      api.createRecord('5530ee93', component.options)
    } else {
      api.reload('5530ee93', component.options)
    }
    module.hot.accept("./StarterSite.vue?vue&type=template&id=5530ee93&", function () {
      api.rerender('5530ee93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepTwo/StarterSite.vue"
export default component.exports